import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout10 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class ProductListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="ProductListView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

ProductListView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func,
};

ProductListView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "ProductListView",
    containerPadding: "0px",
    list: [],
    showPrice: true,
  },
  layout: Layout10,
};
export default ProductListView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/ProductListView.js